import * as React from "react";
import { SVGProps } from "react";
const SvgStoreRetrieve = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 18.333 2.75 22 0 18.333h1.833V13.75h1.834v4.583H5.5ZM16.5 3.667 19.25 0 22 3.667h-1.833V8.25h-1.834V3.667H16.5ZM1.833 7.333H0V5.042L5.042 0h2.291v1.833H5.5L1.833 5.5v1.833Z"
      fill="#FEFEFE"
    />
    <path
      d="m4.583 7.333 2.75-2.75h10.084v12.834H4.583V7.333Z"
      fill="#FEFEFE"
    />
  </svg>
);
export default SvgStoreRetrieve;
